import { useUserStore, useSessionStore } from '@/stores'
import { useAppMachine } from '@/state'
import { useTranslation } from 'i18next-vue'
import { mediator } from '@communication'

export default class DestroyProcedure {
  constructor () {
    const { state } = useAppMachine()
    const { t } = useTranslation()
    this.name = 'destroyProcedure'
    this.state = state
    this.t = t
  }

  install = () => {
    this.addVisibilityChangeListener()
    this.addBeforeUnloadListener()
  }
  
  addVisibilityChangeListener () {
    const user = useUserStore()
    document.addEventListener('visibilitychange', () => {
      user.setPresence(document.visibilityState === 'visible')
      if (user.isClient) {
        if (document.visibilityState === 'hidden') {
          mediator.broadcast({ type: 'video:suspended' })
        } else if (document.visibilityState === 'visible') {
          mediator.broadcast({ type: 'video:resumed' })
        }
      }
    })
  }

  addBeforeUnloadListener () {
    const session = useSessionStore()
    window.addEventListener('beforeunload', (event) => {
      if (this.state.value.matches('app.view.meeting') && !session.sessionFailed) {
        event.preventDefault()
        event.returnValue = this.t('app.unloadConfirm')
      }
    })
  }

  uninstall = () => {}

}
